import type { ReactNode } from 'react';

// The `app/(public)/layout.tsx` main plus, for the two 26 editions, the theme div their
// `app/(public)/26-{co,mx}/layout.tsx` wraps the whole edition in — `/schedule` sits
// directly under `(public)` and has no such div.
//
// It is reproduced here rather than skipped (PORTING.md P4) because every colour and font
// on the grid is a theme-ph26 token: without it the page is wrong, not merely bare. The
// JSON-LD block and the devtools console art the same layout renders are the landing's
// and belong to `sponsors-landing:pages/landing-{26-co,past}`, which deletes this file.
export function Ph26Shell({
  enabled,
  children,
}: {
  enabled: boolean;
  children: ReactNode;
}) {
  return (
    <main className="flex-1">
      {enabled ? (
        <div className="theme-ph26 min-h-screen bg-background font-sans text-foreground">
          {children}
        </div>
      ) : (
        children
      )}
    </main>
  );
}
